<script setup lang="ts">
import { ref, watch } from "vue";
import cloneDeep from "lodash-es/cloneDeep";
import { styleZoom } from "@/common/utils/style";
import type { ReportBlockType } from "@/common/types/report";

const props = defineProps<{
  block: ReportBlockType;
  selectedBlock: string | null;
  zoom: number;
}>();

const internalBlock = ref<ReportBlockType>(cloneDeep(props.block));

watch(
  () => props.block,
  (newValue) => {
    if (!newValue) return;
    internalBlock.value = cloneDeep(newValue);
  },
  { deep: true, immediate: true },
);
</script>

<template>
  <div class="text-block" :style="styleZoom(internalBlock?.style, zoom)">
    <div v-html="internalBlock.text" />
  </div>
</template>

<style lang="scss" scoped>
.text-block {
  min-height: 10px;
  word-break: break-word;
  padding: 3px;

  &:focus {
    outline: 2px dashed #007bff;
    outline-offset: 3px;
  }
}

:deep(p) {
  margin: 0;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
}

:deep(.ql-container.ql-snow) {
  border: none;
}
</style>
